import React from 'react'
import { Check, Verified } from '@mui/icons-material'
import { Box, Button, styled, Typography } from '@mui/material'


const MainBox = styled(Box)(({ theme }) => ({
  width: '22vw',
  margin: theme.spacing(1),
  padding: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#fff',
  border: '1px solid #f50057',
  borderRadius: '10px',
  '&:hover': {
    backgroundColor: '#edefff',
    '& .MuiButton-root': {
      backgroundColor: '#d7bff4',
      color: '#000',
    }
  }
}));


function PurchaseCard({ title, price, license }) {
  return (
    <MainBox>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', my: 2, pb: 1, gap: 1, borderBottom: '1px solid red' }} >
        <Typography variant='h5' fontWeight={600} sx={{ color: '#150e3a' }} >{title}</Typography>
        <Typography variant='h5' fontWeight={600} sx={{ color: '#482e84' }} >{price}</Typography>
        <Button variant='contained' sx={{ bgcolor: '#d7bf44', my: 2 }} >Buy Now</Button>
      </Box>

      <Box sx={{ width: '90%', display: 'flex', flexDirection: 'column', mt: 2, gap: 2 }} >
        {
          license.map((feature) => (
            <Box key={feature} sx={{ display: 'flex', alignItems: 'start', gap: 2 }} >
              <Verified sx={{ fontSize: '1.2rem', color: 'grey' }} /> <Typography sx={{ fontSize: '0.8rem' }} >{feature}</Typography>
            </Box>
          ))
        }
      </Box>

      {/* <Box sx={{ width: '90%', display: 'flex', justifyContent: 'center' }} >
        <Button variant='standard' sx={{ color: '#211a60' }} >See All</Button>
      </Box> */}
    </MainBox>
  )
}

export default PurchaseCard
